import { render } from "./IconChevronRight.vue.js?vue&type=template&id=032cd91f!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconChevronRight.vue?vue&type=template&id=032cd91f"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__